export default __webpack_public_path__ + "img/a1966a96f176801f645cd8eea74fe355.png";